import { accountApplicationReducers } from './accountApplication.reducer';
import accountDetails from './accountDetails';
import { accountHolderReducers } from './accountHolders.reducers';
import { accountsReducers } from './accounts.reducers';
import app from './app';
import { auth } from './auth';
import cashiering from './cashiering';
import configs from './configs';
import investigations from './investigations';
import offerOrders from './offerOrders.reducers';
import offers from './offers.reducers';
import offerWatches from './offerWatches.reducers';
import orders from './order.reducer';
import quoteMedia from './quoteMedia';
import { statementReducers } from './statement.reducer';
import toastMessages from './toastMessages';
import user from './users.reducers';

const reducer = {
  auth,
  user,
  accountDetails,
  accounts: accountsReducers,
  accountHolders: accountHolderReducers,
  accountApplications: accountApplicationReducers,
  statements: statementReducers,
  cashiering,
  offers,
  offerWatches,
  investigations,
  configs,
  quoteMedia,
  orders,
  offerOrders,
  toastMessages,
  app,
};

export default reducer;
